module.exports = __webpack_public_path__ + "static/scale-model-of-travel-sea-vacations-in-milwaukee-wisconsin-5dd36c9f6ff4c5a11f4709a028b0e013.png";